import { config } from './config';

// Функція для реєстрації Service Worker
export function registerSW() {
  // Перевірка на підтримку Service Worker та безпечний контекст
  if ('serviceWorker' in navigator && (window.isSecureContext || window.location.protocol === 'http:')) {
    // Перевірка на localhost або development
    const isLocalhost = Boolean(
      window.location.hostname === 'localhost' ||
      window.location.hostname === '[::1]' ||
      window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
      window.location.hostname.includes('.loc') // для ваших .loc доменів
    );

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      
      const registerOptions: RegistrationOptions = {};
      
      // Для development/staging з самопідписаними сертифікатами
      if (isLocalhost || process.env.NODE_ENV === 'development') {
        console.log('Development mode: registering SW with relaxed security');
      }
      
      navigator.serviceWorker.register(swUrl, registerOptions)
        .then((registration) => {
          console.log('SW registered: ', registration);
          
          // Функція для відправки конфігурації
          const sendConfig = (worker: ServiceWorker) => {
            worker.postMessage({
              type: 'CONFIG',
              manifestPath: `${process.env.PUBLIC_URL}/manifests/${config.brand}/manifest.json`,
              brand: config.brand
            });
          };
          
          // Відправляємо конфігурацію активному worker або чекаємо активації
          if (registration.active) {
            sendConfig(registration.active);
          } else if (registration.installing) {
            registration.installing.addEventListener('statechange', () => {
              if (registration.installing?.state === 'activated') {
                sendConfig(registration.active!);
              }
            });
          }
          
          // Перевірка на оновлення
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // Новий контент доступний
                  console.log('New content is available; please refresh.');
                }
              });
            }
          });
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
          
          // Специфічна обробка SSL помилок
          if (registrationError.name === 'SecurityError') {
            console.warn('Service Worker registration failed due to SSL certificate issues. This is common in development/staging environments.');
            console.warn('For production, ensure valid SSL certificate is installed.');
            
            // Можна показати користувачу повідомлення про обмежену функціональність
            if (process.env.NODE_ENV === 'development') {
              console.info('PWA features will be limited without Service Worker.');
            }
          }
        });
    });
  }
}

// Функція для скасування реєстрації Service Worker
export function unregisterSW() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
